export default function CodeSnippetColumnValidator(values) {
  if (!values.formula) {
    window.appStore.notificationStore.showNotification(
      "Please enter formula",
      "error"
    );
    return false;
  }
  if (!values.options.formula_column) {
    window.appStore.notificationStore.showNotification(
      "Please select a formula data type",
      "error"
    );
    return false;
  }
  return true;
}
